
import React from 'react';
import { useWizardLoader } from './hooks/useWizardLoader';
import MobileWizard from './MobileWizard';
import * as MW from './styles/MobileWizard.styles';

/**
 * This component handles the initial loading of all wizard data.
 * It shows a loading screen and then renders the main MobileWizard
 * component once all data is fetched and parsed.
 */
const WizardDataLoader = React.forwardRef((props, ref) => {
    const { isLoading, initialData } = useWizardLoader();

    if (isLoading || !initialData) {
        return <MW.LoadingWrapper>Loading Mobile App...</MW.LoadingWrapper>;
    }

     return <MobileWizard {...props} initialData={initialData} ref={ref} />
});

export default WizardDataLoader;